// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import commonTable from './components/plugin/common-table'
import searchForm from './components/plugin/search-form'
import submitForm from './components/plugin/submit-form'
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueClipboard from 'vue-clipboard2'
import httpRequest from "@/utils/httpRequest";
import BaiduMap from 'vue-baidu-map'
import directive from './directive'
Vue.prototype.$httpRequest=httpRequest;
Vue.prototype.$store = store;
Vue.use(VueClipboard)
Vue.use(VueQuillEditor)
Vue.component('common-table',commonTable)
Vue.component('search-form',searchForm)
Vue.component('submit-form',submitForm)

Vue.use(directive)
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'x0MbVRUARbhARKT2ff1O539UQ1XSt5gQ'
})
Vue.config.productionTip = false
//设置cookie,放在main.js

Vue.prototype.setCookie = function(c_name,value,expiredays) {
  var exdate=new Date()
  exdate.setDate(exdate.getDate()+expiredays)
  document.cookie=c_name+ "=" +escape(value)+
    ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
};


//获取cookie

Vue.prototype.getCookie=function(c_name) {
  if (document.cookie.length>0)
  {
    var  c_start=document.cookie.indexOf(c_name + "=")
    if (c_start!=-1)
    {
      c_start=c_start + c_name.length+1
      var c_end=document.cookie.indexOf(";",c_start)
      if (c_end==-1) c_end=document.cookie.length
      return unescape(document.cookie.substring(c_start,c_end))
    }
  }
  return ""
};
Vue.prototype.goBack=()=>{
  history.go(-1);
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js